module.exports = __webpack_public_path__ + "img/2296.be44ad4d.gif";